import React from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { CONTACT, BOOKING_QR } from "../../lib/constants";
import { useReveal } from "../../hooks/useReveal";
import { BookingForm } from "./BookingForm";

export const Booking = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="bg-bg-base py-16 md:py-20"
    >
      <div ref={ref} className="reveal max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="overline">{t.booking.overline}</p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-accent-dark mt-4 tracking-tight font-light">
            {t.booking.title}
          </h2>
          <p className="mt-5 text-text-muted text-base md:text-lg leading-relaxed">
            {t.booking.subtitle}
          </p>
        </div>

        {/* Quick booking form */}
        <BookingForm />

        {/* Alternative contact row */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0 md:divide-x divide-border-soft border border-border-soft bg-white">
          <div className="p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-11 h-11 rounded-full bg-bg-alt flex items-center justify-center text-gold shrink-0">
              <MessageCircle size={20} />
            </div>
            <div className="flex-1 space-y-4">
              <div>
                <p className="overline">WhatsApp</p>
                <a
                  href={CONTACT.whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="booking-whatsapp"
                  className="font-serif text-lg md:text-xl text-accent-dark hover:text-gold transition-colors mt-1 leading-tight inline-block"
                >
                  {CONTACT.whatsappNumber}
                </a>
              </div>
              <div>
                <p className="overline">Email</p>
                <a
                  href={CONTACT.mailLink}
                  data-testid="booking-email"
                  className="font-serif text-lg md:text-xl text-accent-dark hover:text-gold transition-colors mt-1 leading-tight inline-block break-all"
                >
                  {CONTACT.email}
                </a>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-10 flex items-center gap-6">
            <div className="bg-white border border-border-soft p-2 shrink-0" data-testid="booking-qr">
              <img
                src={BOOKING_QR}
                alt="QR code for the booking form"
                className="w-24 h-24 md:w-28 md:h-28"
              />
            </div>
            <div>
              <p className="overline">{t.booking.qrLabel}</p>
              <p className="font-serif text-lg md:text-xl text-accent-dark mt-1 leading-tight">
                Scan &amp; book
              </p>
              <p className="mt-2 text-xs text-text-muted leading-relaxed">
                Point your camera here to open the booking form on your phone.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
